import { render, staticRenderFns } from "./ExternalSupervisorDashboard.vue?vue&type=template&id=4325c9b3&scoped=true"
import script from "./ExternalSupervisorDashboard.vue?vue&type=script&lang=js"
export * from "./ExternalSupervisorDashboard.vue?vue&type=script&lang=js"
import style0 from "./ExternalSupervisorDashboard.vue?vue&type=style&index=0&id=4325c9b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4325c9b3",
  null
  
)

export default component.exports